import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({
  title = '',
  description = '',
  icon = 'Activity',
  color = 'blue',
  count = 0,
  action = () => {}
}) => {
  const colorClasses = {
    blue: 'bg-blue-500/10 border-blue-500/20 hover:border-blue-500/40 text-blue-600',
    emerald: 'bg-emerald-500/10 border-emerald-500/20 hover:border-emerald-500/40 text-emerald-600',
    violet: 'bg-violet-500/10 border-violet-500/20 hover:border-violet-500/40 text-violet-600',
    amber: 'bg-amber-500/10 border-amber-500/20 hover:border-amber-500/40 text-amber-600'
  };

  const iconColors = {
    blue: '#3B82F6',
    emerald: '#10B981',
    violet: '#8B5CF6',
    amber: '#F59E0B'
  };

  return (
    <button
      onClick={action}
      className={`w-full text-left bg-white border rounded-xl p-6 transition-all hover:elevation-md elevation-sm ${colorClasses?.[color]}`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 rounded-lg border flex items-center justify-center ${colorClasses?.[color]}`}>
          <Icon name={icon} size={24} color={iconColors?.[color]} />
        </div>
        <div className="px-3 py-1 bg-slate-100 rounded-full">
          <span className="text-sm font-semibold text-slate-700">{count}</span>
        </div>
      </div>

      <h3 className="text-lg font-bold text-slate-900 font-heading mb-2">
        {title}
      </h3>
      <p className="text-sm text-slate-600 font-body">
        {description}
      </p>

      <div className="flex items-center gap-2 mt-4 text-sm font-medium" style={{ color: iconColors?.[color] }}>
        <span>Manage</span>
        <Icon name="ArrowRight" size={16} color={iconColors?.[color]} />
      </div>
    </button>
  );
};

export default QuickActionCard;